
import { useState, useEffect } from 'react';
import { Organization, UserProfile } from '../types';
import { OrganizationService } from '../services/OrganizationService';

interface OrganizationManagementProps {
    userProfile: UserProfile | null | undefined;
    track: (eventName: string, properties?: any) => void;
}

export const useOrganizationManagement = ({ userProfile, track }: OrganizationManagementProps) => {
    const [organization, setOrganization] = useState<Organization | null>(null);
    const [organizations, setOrganizations] = useState<Organization[]>([]);

    // 1. Organization Info Listener
    useEffect(() => {
        if (!userProfile?.orgId) {
            setOrganization(null);
            return;
        }
        return OrganizationService.listenToOrganization(userProfile.orgId, setOrganization);
    }, [userProfile?.orgId]);

    // 2. All Organizations Listener (Populates the `organizations` array for the switcher)
    useEffect(() => {
        if (!userProfile?.orgIds || userProfile.orgIds.length === 0) {
            setOrganizations([]);
            return;
        }
        return OrganizationService.listenToOrganizations(userProfile.orgIds, setOrganizations);
    }, [userProfile?.orgIds]);

    const updateOrganization = async (orgId: string, data: Partial<Organization>) => {
        track('org_settings_updated', { orgId, fields: Object.keys(data) });
        await OrganizationService.updateOrganization(orgId, data);
    };

    return {
        organization,
        organizations,
        updateOrganization
    };
};
